import ConnectorConfirmationView from './ConnectorConfirmationView';

export default ConnectorConfirmationView;
